
import { defineComponent,ref,Ref } from 'vue';

export default defineComponent({
  props:{
    number: Number,
    identity: String
  },
	setup(props,context) {
     const information = ref({
      name: '',
      ID: '',
      identity: (props.identity as string),
      insurance1: false,
      insurance2: false,
    });

    const form = ref(null);
    //单选和多选框的值和函数
    let cnt1 = 0;
    let cnt2 = 0
    const check1 = () => {
      if (information.value.identity === "child" ) {
        if (cnt1 == 0) {
          context.emit("isAdult");
          cnt1++;
        } else {
          cnt1--;
        } 
      } 
    }
     const check2 = () => {
      if (information.value.identity === "adult") {
          if (cnt2 == 0) {
          context.emit("isChild");
          cnt2++;
        } else {
          cnt2--;
        } 
      }
    }
    const insurance1 = () => {
      if (information.value.insurance1 === false) {
        information.value.insurance1 = true;
        context.emit("addInsurance");
      } else {
        information.value.insurance1 = false;
        context.emit("discardInsurance");
      }
    }
     const insurance2 = () => {
      if (information.value.insurance2 === false) {
        information.value.insurance2 = true;
        context.emit("addInsurance");
      } else {
        information.value.insurance2 = false;
         context.emit("discardInsurance");
      }
    }
    //当前表达格式是否正确
    const checkName = (rule:any, value:any, callback:any) => {
      if (!value) {
        return callback(new Error("姓名不能为空"));
      }
      let r =/^[\u4E00-\u9FFF]{2,6}$/;
      if (!r.test(value)) {
        return callback(new Error("姓名应该为2到6个汉字"));
      }
      callback();
    };
    const checkID = (rule:any, value:any, callback:any) => {
      if (!value) {
        return callback(new Error("身份证号不能为空"));
      }
      let r =/^\d{18}$/;
      if (!r.test(value)) {
        return callback(new Error("身份证号应该为18位数字"));
      }
    };
     
    const rules = {
        name: [{validator: checkName, trigger: 'change'}],
        ID: [{validator: checkID, trigger: 'change'}],
    };
    return{
      form,
      check1,
      check2,
      insurance1,
      insurance2,
      //绑定各个输入框的内容
      information,
      //表单验证规则
      rules
    };
  },
});
